import { createSelector } from 'reselect'
import moment from 'moment'

const formatUpcomingDay = t => ({
  ...t,
  label: moment(t.displayDate).format('dddd, MMMM D'),
  value: t.date
})

const formatTimeslot = t => ({ ...t, value: { start: t.start, end: t.end } })

//TODO: get ids from constants file
const sortOrder = items => {
  return [...items].sort((m1, m2) => {
    // If its a m1 is meal is always 1
    if (-1 === [6, 11, 13].indexOf(m1.category_id)) {
      if (-1 === [6, 11, 13].indexOf(m2.category_id)) {
        return 0
      }
      return -1
    } else {
      if (1 === [6, 11, 13].indexOf(m2.category_id)) {
        return 0
      }
      return 1
    }
  })
}

const formatAddress = address => {
  const [street, floor] = address.street.split('\n')

  return {
    ...address,
    floor,
    street,
    label: `${address.street}, ${address.city}, ${address.region}`,
    value: address.postcode
  }
}

const formatZipcode = zipcode => {
  return {
    label: zipcode,
    value: zipcode
  }
}

export const getOrder = createSelector(
  state => state.order.items,
  items => sortOrder(items)
)

export const getProductsIds = createSelector(
  state => state.order.items,
  items => sortOrder(items).map(i => ({ id: i.id, qty: i.qty }))
)

export const getOrderMealCount = createSelector(
  state => state.order.items,
  items => items.reduce((acc, curr) => acc + curr.qty, 0)
)

export const getOrderSubtotal = createSelector(
  state => state.order.items,
  items => items.reduce((acc, curr) => acc + curr.qty * curr.price, 0)
)

export const getOrderSummary = createSelector(
  state => state.order.orderSummary.data,
  orderSummary => orderSummary
)

export const orderSummaryLoading = createSelector(
  state => state.order.orderSummary.loading,
  loading => loading
)

export const orderIsEmpty = createSelector(
  state => state.order.items,
  items => items && !items.length
)

export const getSelectedDeliveryTime = createSelector(
  state => state.order.selectedTimeslot,
  timeslot => timeslot && formatTimeslot(timeslot)
)

export const getSelectedDeliveryDay = createSelector(
  state => state.order.selectedDay,
  day => day && formatUpcomingDay(day)
)

export const getZipcode = createSelector(
  state => state.order.zipcode,
  zipcode => zipcode && formatZipcode(zipcode)
)

export const getTip = createSelector(
  state => state.order.tip,
  tip => tip
)

export const getSelectedDropoff = createSelector(
  state => state.order.dropoff,
  dropoff => dropoff
)

export const getSelectedCard = createSelector(
  state => state.order.selectedCard,
  card => card
)

export const getSelectedAddress = createSelector(
  state => state.order.selectedAddress,
  address => address && formatAddress(address)
)

export const getOrderConfirmation = createSelector(
  state => state.order.orderConfirmation.data,
  orderConfirmation => orderConfirmation
)

export const orderConfirmationLoading = createSelector(
  state => state.order.orderConfirmation.loading,
  loading => loading
)

export const getNote = createSelector(
  state => state.order.note,
  note => note
)

export const getCoupon = createSelector(
  state => state.order.coupon.code,
  coupon => coupon
)

export const couponLoading = createSelector(
  state => state.order.coupon.loading,
  loading => loading
)

export const getOrderComments = createSelector(
  [state => state.order.note, state => state.order.dropoff],
  (note, dropoff) => {
    return `
      Dropoff option: ${dropoff}.
      Comments:
      ${note}
    `
  }
)

export const getLastItemInOrder = createSelector(
  state => state.order.items,
  items => {
    if (items.length) {
      return items.slice(-1)[0]
    }
    return null
  }
)



// WEBPACK FOOTER //
// ./src/selectors/order.js